"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
// @ts-nocheck
const React = __importStar(require("react"));
const SvgStatusYellow = (props) => (React.createElement("svg", Object.assign({ xmlns: "http://www.w3.org/2000/svg", width: 16, height: 16, fill: "none" }, props),
    React.createElement("circle", { cx: 8, cy: 8, r: 8, fill: "#FDCD6C" }),
    React.createElement("path", { fill: "#272D36", fillRule: "evenodd", d: "M8.795 8c0 .437-.363.8-.8.8a.797.797 0 0 1-.79-.8V4.8c0-.437.342-.8.79-.8s.81.363.8.8zm-.758 1.61c.086 0 .171.011.256.054.512.128.907.576.907 1.141C9.2 11.467 8.656 12 7.995 12A1.193 1.193 0 0 1 6.8 10.805c0-.576.416-1.034.96-1.152a.6.6 0 0 1 .192-.042l.018-.004q.016-.006.035-.007.009.001.016.005.009.005.016.006", clipRule: "evenodd" })));
exports.default = SvgStatusYellow;
